import * as Yup from 'yup'

export type MarketingBlackListFormValues = {
  phone: string
  country_code: string
}

export type DeliveryFormValues = {
  name: string
  email: string
  phone: string
  notes: string
}

export type HomeFormValues = {
  name: string
  email: string
  phone: string
  num_of_stories: string
  notes: string
}

export type ContactFormValues = {
  name: string
  email: string
  phone: string
  message: string
}

export const HomeFormSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
  email: Yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .email()
    .required('Required'),
  phone: Yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
  num_of_stories: Yup.string().required('Required'),
  notes: Yup.string().required('Required'),
})

export const DeliveryFormSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
  email: Yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .email()
    .required('Required'),
  phone: Yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
  notes: Yup.string().required('Required'),
})

export const ContactFormSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
  email: Yup.string()
    .email()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
  phone: Yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
})

export const MarketingBlackListFormSchema = Yup.object().shape({
  country_code: Yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
  phone: Yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
})
